import logo from './logo.svg';
import './App.css';
import { AppNavigator } from './AppNavigator/AppNavigator';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RefreshProvider } from './contexts/RefreshContext';
import { useEffect } from 'react';

function App() {
  // Listen for service worker messages to play notification sound (background notifications)
  useEffect(() => {
    const handleSWMessage = (event) => {
      if (event.data?.type === 'PLAY_NOTIFICATION_SOUND') {
        try {
          const audio = new Audio('/notification-sound.wav');
          audio.volume = 0.7;
          audio.play().catch(err => console.log('Sound play failed:', err));
        } catch (e) {
          console.log('Sound init failed:', e);
        }
      }
    };
    navigator.serviceWorker?.addEventListener('message', handleSWMessage);
    return () => navigator.serviceWorker?.removeEventListener('message', handleSWMessage);
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      <RefreshProvider>
        <AuthProvider>
          <AppNavigator />
        </AuthProvider>
      </RefreshProvider>
    </>
  );
}

export default App;
